<template>
  <header
    class="header"
    :class="{
      fixed: isFixed || isOpen
    }"
  >
    <div class="header-wrapper">
      <router-link
        class="logo"
        to="/"
      >
        金十交易学院
      </router-link>

      <span
        class="header-icon"
        :class="{
          isOpen
        }"
        @click="onTriggerMenu"
      />

      <div class="nav">
        <ul>
          <li
            v-for="item in nav"
            :key="item.title"
            :class="{
              active: currentView === item.id
            }"
            @click="onScrollToItem(item.id)"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>
    </div>

    <transition name="fade-transform">
      <div
        v-show="isOpen"
        class="mb-nav"
        @touchmove.prevent=""
      >
        <ul>
          <li
            v-for="item in nav"
            :key="item.title"
            :class="{
              active: currentView === item.id
            }"
            @click="onCloseMenuAndScroll(item.id)"
          >
            {{ item.mbTitle }}
          </li>
        </ul>
      </div>
    </transition>
  </header>
</template>

<script>
import { throttle } from 'throttle-debounce';
import jump from 'jump.js';

export default {
  name: 'Header',
  components: {},
  data() {
    return {
      isFixed: false,
      isOpen: false,
      currentView: 'topic',
      nav: [
        { title: '首页', mbTitle: '免费培训', id: 'topic' },
        { title: '简介', mbTitle: 'TTPS简介', id: 'section-1' },
        { title: '教练', mbTitle: 'TTPS教练', id: 'section-2' },
        { title: '课程', mbTitle: '线下课程', id: 'alpha-section' },
        { title: '权益', mbTitle: '线下权益', id: 'section-5' },
        { title: '花絮', mbTitle: '线下花絮', id: 'section-6' },
        { title: '案例', mbTitle: '学员案例', id: 'section-7' },
        { title: '评价', mbTitle: '学员评价', id: 'section-8' },
        { title: '预约', mbTitle: '预约体验', id: 'section-9' },
      ],
    };
  },
  mounted() {
    this.handleScroll = throttle(500, () => {
      const header = document.querySelector('header');
      this.headerHeight = header?.offsetHeight;
      if ((document.documentElement.scrollTop || document.body.scrollTop) > this.headerHeight) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }

      const sections = this.nav.map((item) => item.id);
      const idsHeight = sections.map((item) => ({
        gap: Math.abs(document.querySelector(`.${item}`) ? document.querySelector(`.${item}`).getBoundingClientRect().top : 10000),
        id: item,
      }));

      idsHeight.sort((a, b) => a.gap - b.gap);

      this.currentView = idsHeight[0].id;
    });

    this.handleScroll();
    document.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    onScrollToItem(el) {
      jump(`.${el}`, {
        duration: 500,
        offset: -this.headerHeight,
      });
    },
    onCloseMenuAndScroll(el) {
      this.isOpen = false;
      this.$nextTick(() => {
        this.onScrollToItem(el);
      });
    },
    onTriggerMenu() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style scoped lang="scss">
$contentWidth: 1440px;
$deviceWidth: 1920px;

.header {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  transition: all 0.3s, background cubic-bezier(0.075, 0.82, 0.165, 1);
  font-size: 0;
  background: rgba(255, 255, 255, .0);

  &-wrapper {
    max-width: 1920px;
    margin: 0 auto;
    width: 100%;
    padding: percentage(24px / $deviceWidth) percentage(240px / $deviceWidth);
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
  }

  &.fixed {
    position: fixed;
    background: rgba(255, 255, 255, .97);
    z-index: 999;
    box-shadow: 1px 6px 17px rgba(37, 37, 37, .1);

    .nav {
      li {
        color: #3A4047;
      }
    }

    .logo {
      background: url("~assets/logo-2.png") center/contain no-repeat;
      @include hdpi() {
        background-image: url("~assets/logo-2@2x.png");
      }
    }
  }

  .logo {
    display: inline-block;
    width: percentage(204px / $deviceWidth);
    padding-top: percentage(52px / $deviceWidth);
    background: url("~assets/logo-m.png") center/contain no-repeat;
    @include hdpi() {
      background-image: url("~assets/logo-m@2x.png");
    }
  }

  .nav {
    font-size: 18px;
    line-height: 24px;
    ul {
      margin: 0;
      padding: 0;
      display: flex;
      list-style: none;
      li {
        padding: 0 24px;
        color: #fff;
        opacity: .6;
        &.active, &:hover {
          opacity: 1;
          font-weight: 600;
        }
        &:hover {
          cursor: pointer;
        }
      }
    }
  }

  @include mediaWidth(1440px) {
    .nav {
      font-size: 16px;
      line-height: 18px;
      ul {
        li {
          padding: 0 16px;
          color: #fff;
        }
      }
    }
    .logo {
      width: percentage(234px / $deviceWidth);
      padding-top: percentage(62px / $deviceWidth);
    }
  }

  @include mediaWidth(1024px) {
    &-wrapper {
      padding: percentage(20px / 1024px) percentage(76px / 1024px);
    }
    .nav {
      font-size: 14px;
      ul {
        li {
          padding: 0 10px;
        }
      }
    }
  }

  @include mediaWidth(#{$mbWidth}) {
    .logo {
      width: percentage(165px / $mbWidth);
      padding-top: percentage(41px / $mbWidth);
      background: url("~assets/logo-m.png") center/contain no-repeat;
      @include hdpi() {
        background-image: url("~assets/logo-m@2x.png");
      }
    }

    .nav {
      display: none;
    }

    &-wrapper {
      position: relative;
      z-index: 9;
    }

    &.fixed {
      .header-wrapper {
        background: #2055EA;
      }

      .logo {
        background: url("~assets/logo-m.png") center/contain no-repeat;
        @include hdpi() {
          background-image: url("~assets/logo-m@2x.png");
        }
      }
    }

    .mb-nav {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 6;
      background: rgba(0, 0, 0, .9);
      padding: percentage(160px / $mbWidth) percentage(120px / $mbWidth) 0;

      ul {
        margin: 0;
        padding: 0;
        list-style: none;

        li {
          padding: 10px 0;
          font-size: 20px;
          color: #fff;
          opacity: .5;
          line-height: 34px;
          text-align: center;
          border-bottom: 1px solid rgba(255, 255, 255, .2);

          &:last-child {
            border-bottom: 0;
          }

          &.active {
            font-weight: 600;
            opacity: 1;
          }
        }
      }
    }

    .header-icon {
      display: block;
      width: 18px;
      height: 18px;
      background: url("~assets/icon-menu.png") center/contain no-repeat;
      &.isOpen {
        width: 16px;
        height: 16px;
        background: url("~assets/icon-close.png") center/contain no-repeat;
      }
    }
  }

  @include mediaWidth(528px) {
    .logo {
      width: 113px;
      height: 28px;
      padding-top: 0;
    }
    .mb-nav {
      ul {
        li {
          font-size: 16px;
        }
      }
    }
  }
}

/* 上往下淡入，下往上淡出 */
/* fade-transform */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.3s;
}
.fade-transform-enter {
  opacity: 0;
  transform: translateY(-10px);
}
.fade-transform-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
